import { CUSTOM_COMPONENTS_CATEGORY, PRICE_UPFRONT_CATEGORY } from '../../../constants';
import ICONS_COMPONENTS_CONFIG from './icons';
import CLOUDINARY_IMAGE_CONFIG from './cloudinaryImage';
import RECOMMENDATIONS_INSPIRE_CAROUSEL_CONFIG from './recommendationsInspireCarousel';
import SEARCH_BAR_CONFIG from './searchBar';
import LISTINGS_COMPONENTS_CONFIG from './listings';
import BUILDER_COMPONENTS_CONFIG from './builder';
import { MODAL_ADAPTER_CONFIG } from './modalAdapter';
import { TABLE_OF_CONTENTS_CONFIG } from './tableOfContents';
import SOCIAL_SHARING_CONFIG from './socialSharing';
import { DM_BRIEF_CREATION_CONFIG } from './dmBriefCreation';
import { DOMAIN_EXPERT_SOURCING_DRAWER_BUTTON_CONFIG } from './domainExpertSourcingDrawer';
import { AB_TESTS_CONFIG } from './abTests';
import { EXPERT_SOURCING_PAYMENT_BUTTON_CONFIG } from './expertSourcingPaymentButton';
import { SOURCING_CARD_CONFIG } from './sourcingCard';
import { TALENT_CARD_GRID_CONFIG } from './talentCardGrid';
import { PRICE_UPFRONT_CONFIG } from './priceUpfront';

const MANUAL_REGISTRATION_COMPONENTS_LIST = {
    Icons: ICONS_COMPONENTS_CONFIG,
    CustomComponents: {
        components: [
            ...CLOUDINARY_IMAGE_CONFIG.components,
            ...SEARCH_BAR_CONFIG.components,
            ...RECOMMENDATIONS_INSPIRE_CAROUSEL_CONFIG.components,
            ...LISTINGS_COMPONENTS_CONFIG.components,
            ...MODAL_ADAPTER_CONFIG.components,
            ...TABLE_OF_CONTENTS_CONFIG.components,
            ...SOCIAL_SHARING_CONFIG.components,
            ...DM_BRIEF_CREATION_CONFIG.components,
            ...DOMAIN_EXPERT_SOURCING_DRAWER_BUTTON_CONFIG.components,
            ...EXPERT_SOURCING_PAYMENT_BUTTON_CONFIG.components,
            ...SOURCING_CARD_CONFIG.components,
            ...TALENT_CARD_GRID_CONFIG.components,
        ],
        category: CUSTOM_COMPONENTS_CATEGORY,
    },
    PriceUpfront: {
        components: [...PRICE_UPFRONT_CONFIG.components],
        category: PRICE_UPFRONT_CATEGORY,
    },
    BuilderComponents: BUILDER_COMPONENTS_CONFIG,
    ABTests: AB_TESTS_CONFIG,
};

export default MANUAL_REGISTRATION_COMPONENTS_LIST;
